// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-jsx": () => import("./../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-index-jsx": () => import("./../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-pages-music-jsx": () => import("./../src/pages/music.jsx" /* webpackChunkName: "component---src-pages-music-jsx" */),
  "component---src-pages-thoughts-jsx": () => import("./../src/pages/thoughts.jsx" /* webpackChunkName: "component---src-pages-thoughts-jsx" */),
  "component---src-templates-thought-jsx": () => import("./../src/templates/thought.jsx" /* webpackChunkName: "component---src-templates-thought-jsx" */)
}

